module.exports = __webpack_public_path__ + "img/icon-pencil.409419f3.svg";